var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconSearchComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-search").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M7.07047 1.98275C4.2606 1.98275 1.98275 4.2606 1.98275 7.07047C1.98275 9.88034 4.2606 12.1582 7.07047 12.1582C9.88034 12.1582 12.1582 9.88034 12.1582 7.07047C12.1582 4.2606 9.88034 1.98275 7.07047 1.98275ZM0.649414 7.07047C0.649414 3.52422 3.52422 0.649414 7.07047 0.649414C10.6167 0.649414 13.4915 3.52422 13.4915 7.07047C13.4915 8.60346 12.9543 10.011 12.0579 11.115L15.2774 14.3346C15.375 14.4322 15.375 14.5905 15.2774 14.6881L14.6881 15.2774C14.5905 15.375 14.4322 15.375 14.3346 15.2774L11.115 12.0579C10.011 12.9543 8.60346 13.4915 7.07047 13.4915C3.52422 13.4915 0.649414 10.6167 0.649414 7.07047Z", fillOpacity: "1" }));
}
var IconSearch = React.forwardRef(IconSearchComponent);
export default IconSearch;
